import { getThemeCssVariables } from "./tokens";
import { CssVariableMap, ThemeTokens } from "./themeTypes";

export function themeToCssVariables(tokens: ThemeTokens): CssVariableMap {
  return getThemeCssVariables(tokens);
}

export function applyTheme(tokens: ThemeTokens, target?: HTMLElement): CssVariableMap {
  const element = target || document.documentElement;
  const variables = themeToCssVariables(tokens);
  Object.entries(variables).forEach(([key, value]) => {
    element.style.setProperty(key, value);
  });
  element.setAttribute("data-theme", tokens.mode);
  document.body?.setAttribute("data-theme", tokens.mode);
  return variables;
}
